// extracted by mini-css-extract-plugin
export default {"container":"AttachedContractDocuments_container__LFzW8","descriptionRow":"AttachedContractDocuments_descriptionRow__ZKRzE"};